import React, { useState, useEffect } from 'react';
import { timeZone } from '../../helper/staticHelper.js'
import { saveGeneralSettings, getGeneralSettings } from '../../helper/apiHelper.js'
import { toast, Bounce } from 'react-toastify';

function General() {
    const [isSaveSent, setIsSaveSent] = useState(true);
    const [isPrevious, setIsPrevious] = useState(true);
    const [isGroup, setIsGroup] = useState(false);
    const [isSpelling, setIsSpelling] = useState(false);
    const [timeZoneValue, setTimeZone] = useState('system');
    const [isSaving, setIsSaving] = useState(false);

    const handleRadioChange = (value, type) => {
        if (type === 'sent') {
            setIsSaveSent(value === 'true');
        }
        if (type === 'previous') {
            setIsPrevious(value === 'true');
        }
        if (type === 'group') {
            setIsGroup(value === 'true');
        }
        if (type === 'spelling') {
            setIsSpelling(value === 'true');
        }
        if (type === 'timezone') {
            setTimeZone(value);
        }
    };

    const save = async () => {
        setIsSaving(true);
        const data = {
            saveSentEmails: isSaveSent,
            includePreviousMessages: isPrevious,
            groupEmails: isGroup,
            enableSpellingCorrection: isSpelling,
            timeZone: timeZoneValue
        }
        const result = await saveGeneralSettings(JSON.stringify(data));
        if (result) {
            toast.success("Saved!", {
                position: "top-center",
                transition: Bounce,
            });
        } else {
            toast.error("Something went wrong!", {
                position: "top-center",
                transition: Bounce,
            });
        }
        setIsSaving(false);
        fetchData();
    }
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getGeneralSettings();
            if (response) {
                setTimeZone(response.time_zone);
                setIsSaveSent(response.is_save_sent);
                setIsPrevious(response.is_previous_msg);
                setIsGroup(response.is_group);
                setIsSpelling(response.is_spell_check);
                localStorage.setItem('timeZone', response.time_zone);
            }

        } catch (error) {
            console.error('Error fetching general settings:', error);
        }
    };

    return (
        <>
            <div className='col'>
                <div className='general-section container-fluid'>
                    <div className="row border-bottom general-row">
                        <div className="col-4">
                            <div className="general-menu-text">Save sent emails</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input
                                    type="radio"
                                    className="input-radio on"
                                    name="Save all sent emails-0"
                                    value="true"
                                    checked={isSaveSent}
                                    onChange={(event) => { handleRadioChange(event.target.value, 'sent') }}
                                />
                                Enable
                            </label>
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input
                                    type="radio"
                                    className="input-radio on"
                                    name="Save all sent emails-0"
                                    value="false"
                                    checked={!isSaveSent}
                                    onChange={(event) => { handleRadioChange(event.target.value, 'sent') }}
                                />
                                Disable
                            </label>
                        </div>
                    </div>
                    <div className="row border-bottom general-row">
                        <div className="col-4">
                            <div className="general-menu-text">Include Previous Messages</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Include Previous Messages-1" value='true' checked={isPrevious} onChange={(event) => { handleRadioChange(event.target.value, 'previous') }} />
                                Enable
                            </label>
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Include Previous Messages-1" value='false' checked={!isPrevious} onChange={(event) => { handleRadioChange(event.target.value, 'previous') }} />
                                Disable
                            </label>
                        </div>
                    </div>
                    <div className="row border-bottom general-row">
                        <div className="col-4">
                            <div className="general-menu-text">Group Email</div>
                        </div><div className="col d-flex justify-content-center flex-column gap-2">
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Group Email-2" value='true' checked={isGroup} onChange={(event) => { handleRadioChange(event.target.value, 'group') }} />
                                Enable
                            </label>
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Group Email-2" value='false' checked={!isGroup} onChange={(event) => { handleRadioChange(event.target.value, 'group') }} />
                                Disable
                            </label>
                        </div>
                    </div>
                    <div className="row border-bottom general-row">
                        <div className="col-4">
                            <div className="general-menu-text">Check Spelling</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Check Spelling-3" value='true' checked={isSpelling} onChange={(event) => { handleRadioChange(event.target.value, 'spelling') }} />
                                Enable
                            </label>
                            <label className="d-flex align-items-center cursor-pointer w-fit-content">
                                <input type="radio" className="input-radio on" name="Check Spelling-3" value='false' checked={!isSpelling} onChange={(event) => { handleRadioChange(event.target.value, 'spelling') }} />
                                Disable
                            </label>
                        </div>
                    </div>
                    <div className="row border-bottom general-row">
                        <div className="col-4">
                            <div className="general-menu-text">Time Zone</div>
                        </div>
                        <div className="col d-flex justify-content-center flex-column gap-2">
                            <select className="select-box" value={timeZoneValue} onChange={(event) => { handleRadioChange(event.target.value, 'timezone') }}>
                                <option value="system">System</option>
                                {
                                    timeZone.map((item, index) => (
                                        <option value={item.zoneName} key={index}>{item.zoneName}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    <div className='general-submit col-4 d-flex justify-content-end'>
                        <button className='general-save-btn' disabled={isSaving} onClick={async () => {
                            await save();
                        }}>Save</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default General;
